import * as CoreFns from './CoreFns';

export function searchEntity(currentList, entityKey){

	var searchOptions = ['fe', 'pu'];
	for (var i5 = 0; i5 < searchOptions.length; i5++){
		var aSSet = searchOptions[i5];
		var feSet = currentList[aSSet];
		if (feSet){
			var feKeys = Object.keys(feSet);
			for (var i = 0; i < feKeys.length; i++){
				var p = searchPage(feSet[feKeys[i]], [aSSet, feKeys[i]], entityKey, currentList);
				if (p){
					return p;
				}
			}		
		}
	}

	var p1 = searchFooter(currentList.fo, ['fo'], entityKey);
	if (p1){
		return p1;
	}

	return false;
}

function searchPage(page, pagePath, entityKey, currentList){
	var nvAdd = searchNavBar(page.nv, pagePath.concat(['nv']), entityKey, currentList);
	if (nvAdd){
		return nvAdd;
	}
	var fePath = pagePath.concat(['_s']);
	var screenSet = page._s;
	var screenKeys = Object.keys(screenSet);
	for (var k = 0; k < screenKeys.length; k++){
		var thisPanel = screenSet[screenKeys[k]];
		var p = searchPanel(thisPanel, fePath.concat([screenKeys[k]]), entityKey);
		if (p){
			return p;
		}
	}

}

function searchFooter(footer, path, entityKey){
	if (footer && footer.i){
		return searchCollection(footer.i, path.concat(['i']), entityKey);
	}
}

function searchNavBar(nv, thisScreenPath, entityType, currentList){
	if (nv.on){
		if (nv.on === 1){
		}else{
			thisScreenPath = ['cn', nv.on, 'nv'];
			nv = CoreFns.goDownPath(currentList, thisScreenPath);
		}
		var p0 = searchCollection(nv.i, thisScreenPath.concat(['i']), entityType);
		if (p0){
			return p0;
		}
		if (nv.navbarCluster){
			var p1 = searchCollection(nv.ic, thisScreenPath.concat(['ic']), entityType);
			if (p1){
				return p1;
			}
			var p2 = searchCollection(nv.ir, thisScreenPath.concat(['ir']), entityType);
			if (p2){
				return p2;
			}
		}
	}
	return false;
}


function searchPanel(thisPanel, panelPath, entityKey){


	var itemPath = panelPath.concat(['i']);
	var p1 = searchCollection(thisPanel.i, itemPath, entityKey);
	if (p1){
		return p1;
	}
	var kItemPath = panelPath.concat(['k']);
	var p2 = searchCollection(thisPanel.k, kItemPath, entityKey);
	if (p2){
		return p2;
	}

	var alerts = thisPanel.al;
	var alertKeys = Object.keys(alerts);
	for (var k1 = 0; k1 < alertKeys.length; k1++){
		var thisAlert = alerts[alertKeys[k1]];
		var p = searchAlert(thisAlert, panelPath.concat(['al', alertKeys[k1]]), entityKey);
		if (p){
			return p;
		}
	}

}

function searchAlert(thisAlert, alertPath, entityKey){
	var p3 = searchCollection(thisAlert.k, alertPath.concat(['k']), entityKey);
	if (p3){
		return p3;
	}
}


function searchThroughItemX(itemX, path, entityKey){
	for (var i = 0; i < itemX.length; i++){
		var anItem = itemX[i];
		if (anItem.t === 't' || anItem.t === 'tb' || anItem.t === 'h' || anItem.t === 'br'){
		}else if (anItem.t === 'a'){
			if (anItem.i === entityKey){
				return {item:anItem, path:path.concat([i])}
			}
		}else{
			console.warn(anItem);
		}
	}
	return false;
}


function searchItem(thisItem, itemPath, entityKey){
	var tt = thisItem.t;
	if (CoreFns.isHolder(tt)){
		var p = searchCollection(thisItem.i, itemPath.concat(['i']), entityKey);
		if (p){
			return p;
		}
	}else if (CoreFns.gotTextX(tt)){
		var p1 = searchThroughItemX(thisItem.x, itemPath.concat(['x']), entityKey);
		if (p1){
			return p1;
		}
	}else if (tt === 'BUTTON' || tt === 'ICON' || tt === 'SPACE' || tt === 'INPUT' || tt === 'VIDEO' || tt === 'IMG' || tt === 'navBrand' || tt === 'navLink' || tt === 'GALLERY' || tt === 'TIMER' || tt === 'LINECHART' || tt === 'BARCHART' || tt === 'PIECHART'){
	}else{
		console.warn(thisItem);
	}

}

function searchCollection(items, itemPath, entityKey){
	var itemKeys = Object.keys(items);
	for (var j = 0; j < itemKeys.length; j++){
		var thisItemKey = itemKeys[j];
		var thisItem = items[thisItemKey];
		var p = searchItem(thisItem, itemPath.concat([thisItemKey]), entityKey);
		if (p){
			return p;
		}
	}

}

export function getASChanges(itemSet, itemT, currentList, userNos){
  var as = itemSet.as;
  var item = itemSet.v;
  var asKeys = Object.keys(as);
  var xx = [];
  asKeys.forEach((aKey, index)=>{
		var uuid = CoreFns.uuidScoped(userNos, currentList, ['as'], []);  
		var existingInside = false;
		if (itemT === 'ALERT'){
			existingInside = searchAlert(item, [], aKey);
		}else if (itemT === 'PANEL'){
			existingInside = searchPanel(item, [], aKey);
		}else if (itemT === 'FOOTER'){
			existingInside = searchFooter(item, [], aKey);
		}else if (itemT === 'navBar'){
			existingInside = searchNavBar(item, [], aKey, {cn:itemSet.cn});
		}else if (itemT === 'fe' || itemT === 'pu'){
			existingInside = searchPage(item, [], aKey, {cn:itemSet.cn});
		}else{
			existingInside = searchItem(item, [], aKey);
		}
		if (existingInside){
			existingInside.item.i = uuid;
			xx.push({t:'w', w:['as', uuid], n:as[aKey]})
		}
  })
  return xx;
}

